import React from 'react';
import Colors from '../constants/Colors';
import {useRulesSystem} from '../hooks/useRulesSystem';
import {isRuleSystemId, RULE_SYSTEMS} from '../utils/rulesSystem';

export default function RulesSelector() {
  const {selectedRules, setSelectedRules} = useRulesSystem();
  return (
    <div style={{background: Colors.dark.background, padding: '10px 16px', display: 'flex', justifyContent: 'center'}}>
      <label style={{display: 'flex', alignItems: 'center', gap: 12, maxWidth: '100%', color: Colors.dark.text, fontFamily: 'system-ui, sans-serif', fontSize: 14}}>
        Rules
        <select
          value={selectedRules}
          onChange={event => {
            if (isRuleSystemId(event.target.value)) setSelectedRules(event.target.value);
          }}
          style={{background: Colors.dark.background, color: Colors.dark.text, border: `1px solid ${Colors.dark.text}`, borderRadius: 8, padding: '8px 12px', font: 'inherit', minWidth: 0, maxWidth: '100%'}}
        >
          {RULE_SYSTEMS.map(system => <option key={system.id} value={system.id}>{system.label}</option>)}
        </select>
      </label>
    </div>
  );
}
